exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.nav-wrapper[data-v-88d3ff3c] {\n  background: #ffffff;\n  -webkit-box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);\n          box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);\n  height: 64px;\n  margin-left: 200px;\n}\n", ""]);

// exports
